<template>
<div class="chapter">
<div class="inner_page">
<h1 class="fm" id="fm"><a id="page_vii"></a><strong>Leading Characters</strong></h1>
<h2 class="section"><em>The Barak (Berkowitz) family</em></h2>
<p class="nonindent1">Z<span class="small">EV</span> B<span class="small">ARAK</span>, born in Vienna, name Hebraized from Wolfgang Berkowitz. Army field officer, military emissary to America, later military attaché in Washington</p>
<p class="nonindent1">Nakhama, his wife</p>
<p class="nonindent1">Noah, his son</p>
<p class="nonindent1">Galia, his daughter</p>
<p class="nonindent1">Ruti, his daughter</p>
<p class="nonindent1">Meyer Berkowitz, his father, in the foreign service</p>
<p class="nonindent1">Michael Berkowitz, his religious brother, a scientist</p>
<p class="nonindent1">Lena Berkowitz, Michael’s irreligious wife</p>
<p class="nonindent1">Reuven, Lena and Michael’s infant son</p>
<h2 class="section"><em>The Pasternak family</em></h2>
<p class="nonindent1">S<span class="small">AM</span> P<span class="small">ASTERNAK</span>, born in Czechoslovakia. Kibbutznik, combat officer, later in military procurement and the Mossad</p>
<p class="nonindent1">Amos, his son</p>
<p class="nonindent1">Ruth, his estranged wife</p>
<h2 class="section"><a id="page_viii"></a><em>The Luria family</em></h2>
<p class="nonindent1">B<span class="small">ENNY</span> L<span class="small">URIA</span>, Sabra, born in Moshe Dayan’s moshav. Air force pilot</p>
<p class="nonindent1">Irit, his wife</p>
<p class="nonindent1">Yael, his sister, later Yossi Nitzan’s wife</p>
<p class="nonindent1">Daphna, his daughter</p>
<p class="nonindent1">Dov, his son</p>
<p class="nonindent1">Danny, his son</p>
<h2 class="section"><em>The Nitzan (Blumenthal) family</em></h2>
<p class="nonindent1">Y<span class="small">OSSI</span> N<span class="small">ITZAN</span>, combat officer, born Joseph Blumenthal in Poland (nickname Don Kishote)</p>
<p class="nonindent1">Leopold, his brother (emigrates from Israel to America, changes name to Lee Bloom)</p>
<p class="nonindent1">Shayna Matisdorf, Yossi’s first love</p>
<p class="nonindent1">Aryeh, son of Yossi and Yael (Luria)</p>
<h2 class="section"><em>The Cunningham family (American)</em></h2>
<p class="nonindent1">C<span class="small">HRISTIAN</span> C<span class="small">UNNINGHAM</span>, a CIA officer</p>
<p class="nonindent1">Emily, his daughter</p>
<p class="nonindent1">Bradford Halliday, army officer, Emily’s suitor</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780795344114_epub_fm_r1.vue?d98cb7b8